import React from 'react';
import styled from 'styled-components';

const BaseStyledDiv = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10001;
  background-color: rgba(0, 0, 0, 0.3);
  display: block;
  overflow: auto;
  overscroll-behavior: contain;
`;

const CloseAreaStyledDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const ImageAreaStyledDiv = styled.div`
  margin: 32px 0px;
  line-height: calc(100vh - 64px);
  text-align: center;
`;

interface Props {
  children: any;
  onClickClose: () => void;
}

export const Overlay = (props: Props) => {
  const { children, onClickClose } = props;

  return (
    <BaseStyledDiv>
      <CloseAreaStyledDiv onClick={onClickClose} />
      <ImageAreaStyledDiv>{children}</ImageAreaStyledDiv>
    </BaseStyledDiv>
  );
};
